import { Component, OnInit } from '@angular/core';
import { AlertService } from "../components/alert/alert.service";
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, Validators } from '@angular/forms';
import { DamserviceService } from "../dam/damservice.service";

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  constructor(
    private alert: AlertService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private fb: FormBuilder,
    private damService: DamserviceService,
  ) { }

  feedbackForm = this.fb.group({
    name: ['', Validators.required],
    email: ['', Validators.required],
    msg: ['', Validators.required],
  });
  submitted: Boolean = false;
  showFeedbackLoader: Boolean = false;
  rating: any;
  feedbackMessage: any;
  feedbackEmoji: any;
  feedbackList = [];
  feedbackRating: any;
  ratingClicked: Boolean = false;

  ngOnInit(): void {
    this.titleService.setTitle("Your feedback | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Welcome to our feedback page, where your opinion matters!'},
      { name: 'keywords', content: 'feedback, ratings' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.getFeedbackList();
  }

  public submitFeedbackForm() {
    this.submitted = true;
    if(this.ratingClicked) {
      if (this.feedbackForm.valid) {
        this.showFeedbackLoader = true;
        this.damService.submitFeedback(this.feedbackForm.value.name, "",
        this.feedbackForm.value.msg, this.feedbackForm.value.email, this.rating).subscribe((data: any) => {
          this.showFeedbackLoader = false;
          this.feedbackMessage = "";
          this.feedbackEmoji = "";
          this.feedbackForm.reset();
          this.ratingClicked = false;
          this.getFeedbackList();
          this.alert.success("Feedback submitted successfully!!")
        },
        (error) => {
          this.showFeedbackLoader = false;
          if(error.status == 500){
            // this.router.navigate(['/maintenance']);
          } else {

          }
        });
      }
    } else {
      this.feedbackMessage = "Select rating!!"
    }
  }

  getFeedbackList() {
    this.damService.getFeedback().subscribe((data: any) => {
      this.feedbackList = data['results']
    },
    (error) => {
      this.showFeedbackLoader = false;
      if(error.status == 500){
      } else {
      }
    });
  }

  deleteFeedbacks() {
    this.damService.deleteFeedback(5).subscribe((data: any) => {

    },
    (error) => {
      this.showFeedbackLoader = false;
      if(error.status == 500){
      } else {
      }
    });
  }

  ratingEmoji(rating: any) {
    this.ratingClicked = true;
    if(rating == 1) {
      this.feedbackMessage = "Very bad";
      this.feedbackEmoji = "🙁";
    } else if(rating == 2) {
      this.feedbackMessage = "Poor";
      this.feedbackEmoji = "😕";
    } else if(rating == 3) {
      this.feedbackMessage = "Medium";
      this.feedbackEmoji = "😐";
    } else if(rating == 4) {
      this.feedbackMessage = "Good";
      this.feedbackEmoji = "😀";
    } else if(rating == 5) {
      this.feedbackMessage = "Excellent";
      this.feedbackEmoji = "😍";
    }
    this.rating = rating;
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }
}
